
import { merge } from 'lodash-es'
import { computed, PropType, ref, defineComponent } from '@nuxtjs/composition-api'
// @ts-expect-error
import { SwiperOptions } from 'swiper/types'
import { useSwiper } from '~/composables/useSwiper'

import ThumbsSlider from '~/components/atoms/ThumbsSlider.vue'
import Lightbox from '~/components/atoms/Lightbox.vue'
import ProductImage from '~/components/molecules/ProductImage.vue'

export default defineComponent({
  components: {
    ThumbsSlider,
    Lightbox,
    ProductImage
  },
  props: {
    images: {
      type: Array as PropType<Array<any>>,
      required: true
    }
  },
  setup (props) {
    const { setInstance, changeSlide, activeSlideIndex } = useSwiper()

    const lightboxVisible = ref<boolean>(false)
    const swiperOptions = ref<SwiperOptions>({
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          allowTouchMove: false
        }
      }
    })
    const thumbsOptions = ref<SwiperOptions>({
      spaceBetween: 16,
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true,
      breakpoints: {
        100: {
          spaceBetween: 10
        },
        768: {
          spaceBetween: 16
        }
      }
    })

    const currentThumbsOptions = computed<SwiperOptions>(() => (
      props.images.length > 6
        ? thumbsOptions.value
        : merge(thumbsOptions.value, { grabCursor: false, allowTouchMove: false }) as any
    ))
    const thumbs = computed(() => props.images.map((i: any) => ({ url: i.mobile.url, alt: i.alt })))

    return {
      setInstance,
      activeSlideIndex,
      changeSlide,
      swiperOptions,
      thumbsOptions,
      currentThumbsOptions,
      lightboxVisible,
      thumbs
    }
  }
})
